import {
    Box,
    Card,
    CardContent,
    Grid,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
    Checkbox,
    Divider,
    IconButton,
    TablePagination
} from '@mui/material';
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { useTheme } from '@mui/material/styles';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState } from 'react';

const headCells = [
    { id: 'select', label: '' },
    { id: 'id', label: 'ID' },
    { id: 'name', label: 'Tên file' },
    { id: 'size', label: 'Kích thước' },
    { id: 'type', label: 'Loại file' },
    { id: 'actions', label: 'Thao tác' }
];

const initialRows = [
    {
        id: 1,
        name: 'Tài liệu A',
        size: '1.3 MB',
        type: 'PDF'
    },
    {
        id: 2,
        name: 'Hình ảnh B',
        size: '2.5 MB',
        type: 'JPG'
    }
];

const UploadFile = () => {
    const pageRows = filteredRows.slice(page * rowsPerPage, (page + 1) * rowsPerPage);

    const [filterName, setFilterName] = useState('');

    const filteredRows = rows.filter((row) => {
        return row.name.toLowerCase().includes(filterName.toLowerCase());
    });
    const sortedRows = rows.sort(compareRows.bind(null, rows));

    // Pagination states
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('name');
    const [rows, setRows] = useState(initialRows);
    const theme = useTheme();
    const [selected, setSelected] = useState([]);
    const isSelected = (id) => selected.indexOf(id) !== -1;

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const compareRows = (rows, a, b) => {
        if (order === 'asc') {
            return a[orderBy].localeCompare(b[orderBy]);
        } else {
            return b[orderBy].localeCompare(a[orderBy]);
        }
    };

    const handleClick = (event, id) => {
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
        }

        setSelected(newSelected);
    };

    const handleDelete = () => {
        setRows(rows.filter((row) => !selected.includes(row.id)));
        setSelected([]);
    };
    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    return (
        <Box sx={{ border: '1px solid #ccc', borderRadius: '8px' }}>
            <Card>
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="h5">Thông tin File tải lên</Typography>
                            <Divider />
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            {headCells.map((cell) => (
                                                <TableCell key={cell.id}>{cell.label}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {pageRows.map((row) => {
                                            const isItemSelected = false;

                                            return (
                                                <TableRow selected={isSelected(row.id)}>
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            checked={isSelected(row.id)}
                                                            onClick={(event) => handleClick(event, row.id)}
                                                        />
                                                    </TableCell>

                                                    <TableCell>{row.id}</TableCell>

                                                    <TableCell>{row.name}</TableCell>

                                                    <TableCell>{row.size}</TableCell>
                                                    <TableCell>{row.type}</TableCell>
                                                    <TableCell align="center" sx={{ pr: 3 }}>
                                                        <IconButton color="primary" size="large" aria-label="view">
                                                            <VisibilityTwoToneIcon />
                                                        </IconButton>
                                                        <IconButton color="secondary" size="large" aria-label="edit">
                                                            <EditTwoToneIcon />
                                                        </IconButton>
                                                        <IconButton onClick={handleDelete}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
            <TablePagination
                rowsPerPageOptions={[5, 10, 15]}
                count={filteredRows.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </Box>
    );
};

export default UploadFile;
